import { BehaviorSubject } from 'rxjs';
import { Service } from '../../../../symphony';

export interface IModalMessageType {
    type: string;
    message: string;
}

@Service()
export class MailingDataService {
	public loading$ = new BehaviorSubject<boolean>(false);

	public modalMessage$ = new BehaviorSubject<IModalMessageType>(null);

	public teamsLoading$ = new BehaviorSubject<boolean>(false);

	public teamsModal$ = new BehaviorSubject<'success' | 'fail' | null>(null);
}
